import type { ReactNode } from 'react'

export function PageShell({
  id,
  isActive,
  children,
}: {
  id: string
  isActive: boolean
  children: ReactNode
}) {
  return (
    <div id={id} className={`page ${isActive ? 'active' : ''}`}>
      {children}
    </div>
  )
}

